import { VueFbq } from 'vue3-facebook-pixel'

export default function (app, env) {
    const pixelId = env.VITE_FACEBOOK_PIXEL;
	if (pixelId) {
        app.use(VueFbq, { pixelId: pixelId, debug: true });
    }
}